import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// import { BedOptions } from 'components/UserCabinet/BedOptions/BedOptions.jsx';
import { UserBedOptions } from './UserBedOptions/UserBedOptions';
const testRoom = { 1: { single: 1, double: 0 }, 2: { single: 0, double: 1 }, 3: { hostel: true, total: 25, free: 7 } };
export const IconRoomComponent = ({ room = testRoom, user = true }) => {
    return (_jsx(_Fragment, { children: _jsx(UserBedOptions, { options: room, user: user, requestCardMain: "hostel" }) }));
};
